import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'recompose';
import { IRootState } from '../../../typings';
import { deleteBroadcastAffiliation, fetchBroadcastAffiliation, updateBroadcastAffiliation } from '../actions';

type IOwnProps = RouteComponentProps<{ id: string }>;

const mapDispatchToProps = {
  fetchBroadcastAffiliation,
  deleteBroadcastAffiliation,
  updateBroadcastAffiliation,
};

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => {
  const id = ownProps.match.params.id;

  return {
    id,
    affiliation: state.broadcastAffiliation.detail[id],
    fetching: state.broadcastAffiliation.fetching,
  };
};

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  InjectedIntlProps &
  IOwnProps;

const reduxConnector = connect(mapStateToProps, mapDispatchToProps);

export const connector = compose<IComponentProps, IOwnProps>(reduxConnector, injectIntl);
